import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_TOPIC_MODELLING_JOBS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the topic modelling jobs.'),
      403: i18n.t('You are not allowed to fetch the topic modelling jobs.'),
      404: i18n.t('The topic modelling jobs you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the topic modelling jobs.'),
      default: i18n.t('An error occurred fetching the topic modelling jobs.')
    }
  },
  CREATE_TOPIC_MODELLING_JOB: {
    ERROR: {
      401: i18n.t('You are not authorized to create the topic modelling job.'),
      403: i18n.t('You are not allowed to create the topic modelling job.'),
      404: i18n.t('The topic modelling job you are trying to create does not exist.'),
      500: i18n.t('An error occurred creating the topic modelling job.'),
      default: i18n.t('An error occurred creating the topic modelling job.')
    },
    SUCCESS: {
      200: i18n.t('Topic modelling job created successfully.')
    }
  },
  FETCH_TOPIC_MODELLING_JOB: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the topic modelling job.'),
      403: i18n.t('You are not allowed to fetch the topic modelling job.'),
      404: i18n.t('The topic modelling job you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the topic modelling job.'),
      default: i18n.t('An error occurred fetching the topic modelling job.')
    }
  },
  FETCH_TOPIC_MODELLING_JOB_TOPICS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the topics.'),
      403: i18n.t('You are not allowed to fetch the topics.'),
      404: i18n.t('The topics you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the topics.'),
      default: i18n.t('An error occurred fetching the topics.')
    }
  },
  FETCH_TOPIC_MODELLING_JOB_CORPUS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the missed questions.'),
      403: i18n.t('You are not allowed to fetch the missed questions.'),
      404: i18n.t('The missed questions you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the missed questions.'),
      default: i18n.t('An error occurred fetching the missed questions.')
    }
  }
};
